const chartDealConversion = {
  data: () => ({
    interval: 'one',
    chartData: {},
    options: {},
    labels: [],
    deals: [],
    show: false,
  }),

  methods: {
    getList () {
      this.show = this.isValid(this.data);

      if (this.show) {
        this.list = this.data.data[0].items[0].stages || [];
        this.getChartData();
      }
    },

    setChartData (labels, data0, data1) {
      this.chartData = {
        datasets: [data0, data1],
        labels: labels.map((item) => this.__(item)),
      };
    },

    setOptions (scales) {
      this.options = {
        stacked: true,
        scales,
        tooltips: {
          enabled: false,
          mode: 'point',
          position: 'custom',
          callbacks: {
            title (item, data) {
              if (data.labels.length - 1 !== item[0].index) {
                return data.datasets[item[0].datasetIndex].label;
              }

              return item[0].datasetIndex ? 'Perdidos' : 'Ganhos';
            },

            label (item) {
              const label = `<span class="chartjs-tooltip-label">${item.xLabel > 1 ? 'NEGÓCIOS' : 'NEGÓCIO'}`;

              return `${label}</span> <span class="chartjs-tooltip-value">${item.xLabel}</span>`;
            },
          },
        },
        legend: {
          display: false,
        },
        plugins: {
          datalabels: {
            textAlign: 'center',
            font: {
              size: 10,
              weight: 700,
            },
            color: (ctx) => {
              if (! ctx.datasetIndex && ctx.dataIndex === ctx.dataset.data.length - 1) {
                return '#242424';
              }
              return '#FFF';
            },
          },
        },
        responsive: true,
        maintainAspectRatio: false,
      };
    },

    getChartData () {
      let wonCount; let
        lostCount = 0;
      const progressedColor = [];

      this.labels = [];
      this.deals.progressed = [];
      this.deals.lost = [];

      this.list.forEach((element) => {
        this.labels.push(this.getStageName(element.id));
        this.deals.progressed.push(element.count.progressed);
        this.deals.lost.push(element.count.lost);

        wonCount = element.count.progressed;
        lostCount += element.count.lost;

        progressedColor.push(this.background[0]);
      });

      this.labels.push('Ganhos / Perdidos');
      this.deals.progressed.push(wonCount);
      this.deals.lost.push(lostCount);
      progressedColor.push(this.background[1]);

      const percentage = this.labels.length / 13;

      const data0 = {
        xAxisID: 'x-axis-bottom',
        label: 'Conversão para o estágio seguinte',
        data: this.deals.progressed,
        categoryPercentage: percentage,
        backgroundColor: progressedColor,
        stack: 'status',
      };

      const data1 = {
        xAxisID: 'x-axis-bottom',
        label: 'Perdidos neste estágio',
        data: this.deals.lost,
        categoryPercentage: percentage,
        backgroundColor: this.background[2],
        stack: 'status',
      };

      this.setChartData(this.labels, data0, data1);
      this.setOptions(this.getScales());
    },

    getScales () {
      const yAxisLabel = {
        ticks: {
          callback: (value) => (value.length > 20 ? value.substring(0, 17).concat('...') : value),
          fontSize: 12,
          fontStyle: 400,
          fontWeight: 400,
        },
        gridLines: {
          display: true,
          drawBorder: false,
          offsetGridLines: false,
          borderDash: [3],
          color: '#e0dbe8',
        },
      };

      const xAxisBottom = {
        id: 'x-axis-bottom',
        type: 'linear',
        position: 'bottom',
        ticks: {
          fontSize: 10,
          fontStyle: 400,
          fontWeight: 400,
        },
        gridLines: {
          display: true,
          drawBorder: false,
          drawOnChartArea: true,
          offsetGridLines: false,
          borderDash: [3],
          zeroLineWidth: 0,
          color: '#e0dbe8',
          drawTicks: true,
        },
      };

      return {
        xAxes: [xAxisBottom],
        yAxes: [yAxisLabel],
      };
    },
  },
};

export default chartDealConversion;
